import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useApiToken } from '../auth/AuthProvider';
import { getAppSettings, AppSettings } from './api';

const DEFAULT_MILEAGE_RATE = 0.725;

interface AppSettingsContextValue {
  mileageRate: number;
  refreshSettings: () => Promise<void>;
}

const AppSettingsContext = createContext<AppSettingsContextValue>({
  mileageRate: DEFAULT_MILEAGE_RATE,
  refreshSettings: async () => {},
});

export function AppSettingsProvider({ children }: { children: React.ReactNode }) {
  const getToken = useApiToken();
  const [settings, setSettings] = useState<AppSettings>({ mileage_rate: DEFAULT_MILEAGE_RATE });

  const refreshSettings = useCallback(async () => {
    try {
      const token = await getToken();
      const fetched = await getAppSettings(token);
      setSettings(fetched);
    } catch {
      // Keep defaults on failure
    }
  }, [getToken]);

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  return (
    <AppSettingsContext.Provider value={{ mileageRate: settings.mileage_rate, refreshSettings }}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings(): AppSettingsContextValue {
  return useContext(AppSettingsContext);
}
